import { render } from "./coursesView.vue?vue&type=template&id=34c55838"
import script from "./coursesView.vue?vue&type=script&lang=js"
export * from "./coursesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__